import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import CheckBox from '../../CheckBox';
import { ButtonPanelWrapper } from '../styles';

const CorrelationContentEditorFooter = ({ data, payload, setPayload, loading = false, updating = false }) => {
  const isUpdating = loading || updating;

  const [redoable, setRedoable] = useState(data.redoable);

  useEffect(() => {
    if (!isUpdating && data.redoable !== redoable) {
      setPayload({ ...payload, redoable, legend_list_id: data.correlation_list_id, immediateSave: true });
    }
  }, [redoable]);

  return (
    <ButtonPanelWrapper>
      <CheckBox
        id="redoQuiz"
        text={i18n.__('quiz_redoable')}
        defaultChecked={redoable}
        onChange={() => setRedoable(!redoable)}
        value={1}
        lightMode={true}
        disabled={loading}
      />
    </ButtonPanelWrapper>
  );
};

export default CorrelationContentEditorFooter;

CorrelationContentEditorFooter.propTypes = {
  data: PropTypes.object.isRequired,
  payload: PropTypes.object.isRequired,
  setPayload: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  updating: PropTypes.bool,
};
